/**
 * Resolve a section heading for storefront display.
 * Uses Contentful `heading` only — `title` is the CMS entry name and must not render.
 *
 * @param {Object} [component]
 * @param {string} [fallback=''] - Optional caller fallback (e.g. account landing copy)
 * @returns {string}
 */
export function resolveContentfulSectionHeading(component, fallback) {
  const fromHeading = typeof component?.heading === 'string' ? component.heading.trim() : '';

  if (fromHeading) {
    return fromHeading;
  }

  return fallback ?? '';
}
